import { FaPhoneAlt, FaMapMarkerAlt } from 'react-icons/fa';

export default function Topbar() {
  return (
    <div className="w-full bg-[hsl(219,100%,8%)] text-white/75 text-sm py-3 px-4 flex flex-col items-center justify-between">
      <div className="flex items-center gap-8 justify-center w-full">
        <a
          href="tel:+919838778808"
          className="flex items-center gap-2 no-underline hover:text-accent-cyan focus:text-accent-cyan"
          style={{ textDecoration: 'none' }}
        >
          <FaPhoneAlt className="text-accent-cyan" /> +91 983 877 8808
        </a>
        <a
          href="https://maps.app.goo.gl/nGxMcZ5HkArit4428"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 no-underline hover:text-accent-cyan focus:text-accent-cyan"
          style={{ textDecoration: 'none' }}
        >
          <FaMapMarkerAlt className="text-accent-cyan" /> 8, Pink City,
          Jankipuram Extension, Lucknow - 226031
        </a>
      </div>
      {/* <div className="flex items-center gap-4 justify-center w-full mt-2">
        <a href="#" className="hover:text-accent-cyan">
          <FaFacebookF />
        </a>
        <a href="#" className="hover:text-accent-cyan">
          <FaTwitter />
        </a>
        <a href="#" className="hover:text-accent-cyan">
          <FaDribbble />
        </a>
        <a href="#" className="hover:text-accent-cyan">
          <FaInstagram />
        </a>
      </div> */}
    </div>
  );
}
